import React from "react";
import jobsData from "../../JobOpenings.json";
import careersImage from "../../images/services/DSC_2376.jpg";

const benefitGroups = [
  {
    icon: "fa-medkit",
    title: "Health Coverage",
    items: ["Major medical", "Dental", "Vision"],
  },
  {
    icon: "fa-shield",
    title: "Protection",
    items: [
      "Group accident",
      "Critical illness",
      "Short-term and long-term disability",
      "Life insurance",
    ],
  },
  {
    icon: "fa-money",
    title: "Pay And Retirement",
    items: ["Top pay", "401k with company match"],
  },
  {
    icon: "fa-calendar-check-o",
    title: "Paid Time Away",
    items: ["Paid vacations", "Personal days", "Holidays"],
  },
];

const Careers = () => {
  const openings = jobsData.JobOpenings || [];

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Careers</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Homepage" href="/">
                      <i className="fa fa-house" /> &nbsp; Home
                    </a>
                  </span>
                  <span>Careers</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <main className="brw-careers">
        <section className="brw-careers__hero">
          <div className="container">
            <div className="brw-careers__hero-grid">
              <div className="brw-careers__copy">
                <span className="brw-careers__eyebrow">Careers at BRW</span>
                <h1>Build Central Florida With Us</h1>
                <p>
                  Join field, equipment, office, and project teams working on
                  utilities, earthwork, asphalt, concrete, and roadway
                  construction across the region.
                </p>
                <div className="brw-careers__actions">
                  <a className="brw-careers__primary" href="/Join">
                    <span>Apply here to join the team</span>
                    <i className="fa fa-arrow-right" aria-hidden="true"></i>
                  </a>
                </div>
              </div>

              <div className="brw-careers__media">
                <img src={careersImage} alt="BRW Contracting paving crew at work" />
                <div className="brw-careers__stat">
                  <strong>{openings.length}</strong>
                  <span>Current openings</span>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="brw-careers__openings" id="open-positions">
          <div className="container">
            <div className="brw-careers__section-head">
              <span>Open Positions</span>
              <h2>Current Roles</h2>
            </div>

            <div className="brw-careers__job-grid">
              {openings.map((job) => (
                <article className="brw-careers__job" key={job.id}>
                  <span>{String(job.id).padStart(2, "0")}</span>
                  <h3>{job.title}</h3>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="brw-careers__benefits">
          <div className="container">
            <div className="brw-careers__benefits-panel">
              <div className="brw-careers__benefits-intro">
                <span>Benefits Package</span>
                <h2>Built To Support The People Doing The Work.</h2>
                <p>
                  BRW Contracting offers a complete benefit package for field,
                  equipment, and office team members.
                </p>
              </div>

              <div className="brw-careers__benefit-grid">
                {benefitGroups.map((group) => (
                  <article className="brw-careers__benefit-card" key={group.title}>
                    <i className={`fa ${group.icon}`} aria-hidden="true"></i>
                    <div>
                      <h3>{group.title}</h3>
                      <ul>
                        {group.items.map((item) => (
                          <li key={item}>{item}</li>
                        ))}
                      </ul>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="brw-careers__apply">
          <div className="container">
            <div className="brw-careers__apply-bar">
              <div>
                <span>Ready to apply?</span>
                <h2>Send us your role interest and work history.</h2>
                <p className="brw-careers__driver-note">
                  To apply for the CDL Driver Position, please click the Driver
                  Portal button.
                </p>
              </div>
              <div className="brw-careers__apply-links">
                <a className="brw-careers__apply-main" href="/Join">
                  <span>Start Application</span>
                  <i className="fa fa-arrow-right" aria-hidden="true"></i>
                </a>
                <a
                  className="brw-careers__apply-secondary"
                  href="https://www.indeed.com/cmp/B.r.w.-Contracting,-Inc./jobs?q=&l=#cmp-skip-header-desktop"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-external-link" aria-hidden="true"></i>
                  Indeed Listings
                </a>
                <a
                  className="brw-careers__apply-secondary"
                  href="https://www.mydriverfiles.com/brw-contracting-inc/apply"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fa fa-truck" aria-hidden="true"></i>
                  Driver Portal
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>

      <style jsx>{`
        .brw-careers {
          background: #f2f5f8;
          color: #061f3f;
        }

        .brw-careers,
        .brw-careers *,
        .brw-careers *::before,
        .brw-careers *::after {
          box-sizing: border-box;
        }

        .brw-careers .container {
          max-width: 1220px;
        }

        .brw-careers__hero {
          padding: 64px 0 34px;
        }

        .brw-careers__hero-grid {
          display: grid;
          grid-template-columns: minmax(0, 0.43fr) minmax(0, 0.57fr);
          gap: 28px;
          align-items: stretch;
        }

        .brw-careers__copy {
          display: flex;
          min-height: 420px;
          flex-direction: column;
          justify-content: center;
          padding: 46px;
          border-radius: 8px;
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.1) 0%, rgba(255, 173, 0, 0) 36%),
            #061f3f;
          color: #fff;
        }

        .brw-careers__eyebrow,
        .brw-careers__section-head span,
        .brw-careers__benefits-intro span,
        .brw-careers__apply-bar span {
          display: inline-flex;
          width: fit-content;
          margin-bottom: 12px;
          color: #ffad00;
          font-size: 0.74rem;
          font-weight: 800;
          letter-spacing: 0;
          line-height: 1.2;
          text-transform: uppercase;
        }

        .brw-careers__copy h1 {
          max-width: 520px;
          margin: 0;
          color: #fff;
          font-size: clamp(2.25rem, 4vw, 4.15rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.02;
        }

        .brw-careers__copy p {
          max-width: 560px;
          margin: 20px 0 0;
          color: rgba(255, 255, 255, 0.78);
          font-size: 1rem;
          line-height: 1.75;
        }

        .brw-careers__actions {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 28px;
        }

        .brw-careers__primary,
        .brw-careers__secondary,
        .brw-careers__apply-links a {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          min-height: 44px;
          padding: 0 18px;
          border-radius: 6px;
          font-size: 0.86rem;
          font-weight: 800;
          line-height: 1.2;
          text-decoration: none;
          text-transform: uppercase;
          transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
        }

        .brw-careers__primary {
          gap: 14px;
          min-height: 54px;
          padding: 0 12px 0 22px;
          border: 1px solid rgba(255, 173, 0, 0.7);
          border-radius: 7px;
          background: linear-gradient(135deg, #ffbd2e 0%, #ff9f00 100%);
          color: #061f3f;
          font-size: 0.95rem;
          text-transform: none;
          box-shadow: 0 16px 36px rgba(255, 173, 0, 0.28);
        }

        .brw-careers__primary i,
        .brw-careers__apply-main i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 6px;
          background: rgba(6, 31, 63, 0.12);
          color: #061f3f;
          font-size: 0.82rem;
          transition: transform 0.2s ease, background 0.2s ease;
        }

        .brw-careers__secondary {
          border: 1px solid rgba(255, 255, 255, 0.18);
          background: rgba(255, 255, 255, 0.08);
          color: #fff;
        }

        .brw-careers__primary:hover,
        .brw-careers__secondary:hover,
        .brw-careers__apply-links a:hover {
          transform: translateY(-1px);
          text-decoration: none;
        }

        .brw-careers__primary:hover {
          color: #061f3f;
          box-shadow: 0 20px 42px rgba(255, 173, 0, 0.34);
        }

        .brw-careers__primary:hover i,
        .brw-careers__apply-main:hover i {
          transform: translateX(2px);
          background: rgba(6, 31, 63, 0.16);
        }

        .brw-careers__secondary:hover {
          background: rgba(255, 255, 255, 0.14);
          color: #fff;
        }

        .brw-careers__media {
          position: relative;
          min-height: 420px;
          overflow: hidden;
          border-radius: 8px;
          background: #061f3f;
          box-shadow: 0 24px 70px rgba(6, 31, 63, 0.16);
        }

        .brw-careers__media::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(180deg, rgba(6, 31, 63, 0.02) 35%, rgba(6, 31, 63, 0.68) 100%);
          pointer-events: none;
        }

        .brw-careers__media img {
          width: 100%;
          height: 100%;
          min-height: 420px;
          display: block;
          object-fit: cover;
          object-position: center;
          filter: saturate(1.08) contrast(1.04);
        }

        .brw-careers__stat {
          position: absolute;
          right: 22px;
          bottom: 22px;
          z-index: 1;
          min-width: 168px;
          padding: 18px;
          border-radius: 8px;
          background: rgba(6, 31, 63, 0.82);
          color: #fff;
        }

        .brw-careers__stat strong,
        .brw-careers__stat span {
          display: block;
        }

        .brw-careers__stat strong {
          color: #ffad00;
          font-size: 2rem;
          line-height: 1;
        }

        .brw-careers__stat span {
          margin-top: 5px;
          font-size: 0.82rem;
          font-weight: 700;
          line-height: 1.3;
          text-transform: uppercase;
        }

        .brw-careers__openings {
          padding: 18px 0 34px;
        }

        .brw-careers__section-head {
          display: flex;
          flex-direction: column;
          gap: 12px;
          align-items: flex-start;
          margin-bottom: 20px;
        }

        .brw-careers__section-head span {
          margin: 0;
        }

        .brw-careers__section-head h2 {
          margin: 0;
          color: #061f3f;
          font-size: clamp(1.9rem, 3vw, 3rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.04;
        }

        .brw-careers__job-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 10px;
        }

        .brw-careers__job {
          display: grid;
          grid-template-columns: 42px 1fr;
          gap: 12px;
          align-items: center;
          min-height: 64px;
          margin: 0;
          padding: 12px 14px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          border-radius: 8px;
          background: rgba(255, 255, 255, 0.92);
          box-shadow: 0 10px 28px rgba(6, 31, 63, 0.05);
        }

        .brw-careers__job span {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 6px;
          background: rgba(255, 173, 0, 0.16);
          color: #9d6500;
          font-size: 0.82rem;
          font-weight: 800;
          line-height: 1;
        }

        .brw-careers__job h3 {
          margin: 0;
          color: #061f3f;
          font-size: 1rem;
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.25;
        }

        .brw-careers__benefits {
          padding: 8px 0 34px;
        }

        .brw-careers__benefits-panel {
          display: grid;
          grid-template-columns: minmax(260px, 0.32fr) minmax(0, 0.68fr);
          gap: 24px;
          align-items: stretch;
          padding: 24px;
          border-radius: 8px;
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.08) 0%, rgba(255, 255, 255, 0) 32%),
            #fff;
          box-shadow: 0 20px 54px rgba(6, 31, 63, 0.08);
        }

        .brw-careers__benefits-intro {
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 20px;
          border-radius: 8px;
          background: #061f3f;
          color: #fff;
        }

        .brw-careers__benefits-intro span {
          margin-bottom: 10px;
        }

        .brw-careers__benefits-intro h2 {
          margin: 0;
          color: #fff;
          font-size: clamp(1.55rem, 2.5vw, 2.45rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.08;
        }

        .brw-careers__benefits-intro p {
          margin: 16px 0 0;
          color: rgba(255, 255, 255, 0.74);
          font-size: 0.96rem;
          line-height: 1.65;
        }

        .brw-careers__benefit-grid {
          display: grid;
          grid-template-columns: repeat(2, minmax(0, 1fr));
          gap: 10px;
        }

        .brw-careers__benefit-card {
          display: grid;
          grid-template-columns: 42px 1fr;
          gap: 12px;
          align-items: start;
          min-height: 132px;
          padding: 16px;
          border: 1px solid rgba(6, 31, 63, 0.08);
          border-radius: 8px;
          background: #f7f9fc;
        }

        .brw-careers__benefit-card i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 42px;
          height: 42px;
          border-radius: 6px;
          background: rgba(255, 173, 0, 0.16);
          color: #9d6500;
          font-size: 1rem;
        }

        .brw-careers__benefit-card h3 {
          margin: 0;
          color: #061f3f;
          font-size: 1rem;
          font-weight: 700;
          line-height: 1.22;
        }

        .brw-careers__benefit-card ul {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          margin: 10px 0 0;
          padding: 0;
          list-style: none;
        }

        .brw-careers__benefit-card li {
          display: inline-flex;
          align-items: center;
          min-height: 26px;
          padding: 5px 8px;
          border-radius: 999px;
          background: #fff;
          color: #5b6b7d;
          font-size: 0.82rem;
          font-weight: 700;
          line-height: 1.2;
        }

        .brw-careers__apply {
          padding: 0 0 82px;
        }

        .brw-careers__apply-bar {
          display: grid;
          grid-template-columns: minmax(0, 0.56fr) minmax(280px, 0.44fr);
          gap: 22px;
          align-items: center;
          padding: 28px;
          border: 1px solid rgba(6, 31, 63, 0.06);
          border-radius: 8px;
          background:
            linear-gradient(135deg, rgba(255, 173, 0, 0.08) 0%, rgba(255, 255, 255, 0) 34%),
            #fff;
          box-shadow: 0 24px 62px rgba(6, 31, 63, 0.1);
        }

        .brw-careers__apply-bar > div > span {
          margin-bottom: 8px;
        }

        .brw-careers__apply-bar h2 {
          margin: 0;
          color: #061f3f;
          font-size: clamp(1.35rem, 2.2vw, 2.1rem);
          font-weight: 700;
          letter-spacing: 0;
          line-height: 1.14;
        }

        .brw-careers__driver-note {
          max-width: 620px;
          margin: 10px 0 0;
          color: #5b6b7d;
          font-size: 0.94rem;
          font-weight: 600;
          line-height: 1.55;
        }

        .brw-careers__apply-links {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
          justify-self: end;
          width: min(100%, 430px);
        }

        .brw-careers__apply-links a {
          gap: 8px;
          border: 1px solid rgba(6, 31, 63, 0.1);
          background: #f6f8fb;
          color: #061f3f;
        }

        .brw-careers__apply-links .brw-careers__apply-main {
          position: relative;
          grid-column: 1 / -1;
          justify-content: center;
          gap: 0;
          min-height: 54px;
          padding: 0 52px;
          border-color: #ffad00;
          background: linear-gradient(135deg, #ffbd2e 0%, #ff9f00 100%);
          box-shadow: 0 14px 32px rgba(255, 173, 0, 0.22);
        }

        .brw-careers__apply-main span {
          position: absolute;
          top: 50%;
          left: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: auto;
          color: #061f3f;
          line-height: 1;
          text-align: center;
          white-space: nowrap;
          transform: translate(-50%, -50%);
        }

        .brw-careers__apply-main i {
          position: absolute;
          top: 50%;
          right: 22px;
          width: auto;
          height: auto;
          border-radius: 0;
          background: transparent;
          font-size: 0.82rem;
          line-height: 1;
          transform: translateY(-50%);
        }

        .brw-careers__apply-links .brw-careers__apply-secondary {
          min-height: 42px;
          background: #fff;
          color: #061f3f;
        }

        .brw-careers__apply-secondary i {
          color: #9d6500;
          font-size: 0.82rem;
        }

        .brw-careers__apply-links a:hover {
          color: #061f3f;
          box-shadow: 0 12px 26px rgba(6, 31, 63, 0.09);
        }

        .brw-careers__apply-main:hover {
          box-shadow: 0 18px 38px rgba(255, 173, 0, 0.28);
        }

        .brw-careers__apply-main:hover i {
          background: transparent;
          transform: translateY(-50%) translateX(2px);
        }

        @media (min-width: 1200px) {
          .brw-careers__job-grid {
            grid-template-columns: repeat(3, minmax(0, 1fr));
          }
        }

        @media (max-width: 991px) {
          .brw-careers__hero {
            padding-top: 44px;
          }

          .brw-careers__hero-grid,
          .brw-careers__benefits-panel,
          .brw-careers__apply-bar {
            grid-template-columns: 1fr;
          }

          .brw-careers__copy,
          .brw-careers__media,
          .brw-careers__media img {
            min-height: 360px;
          }

          .brw-careers__apply-links {
            justify-content: flex-start;
            justify-self: stretch;
            width: 100%;
          }

        }

        @media (max-width: 767px) {
          .brw-careers__hero {
            padding: 34px 0 24px;
          }

          .brw-careers__copy {
            min-height: auto;
            padding: 28px;
          }

          .brw-careers__copy h1 {
            font-size: 2.1rem;
          }

          .brw-careers__media,
          .brw-careers__media img {
            min-height: 280px;
          }

          .brw-careers__job-grid {
            grid-template-columns: 1fr;
          }

          .brw-careers__benefits-panel {
            padding: 18px;
          }

          .brw-careers__benefits-intro {
            padding: 22px;
          }

          .brw-careers__benefit-grid {
            grid-template-columns: 1fr;
          }

          .brw-careers__apply-links a {
            width: 100%;
          }

          .brw-careers__apply-links {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </>
  );
};

export default Careers;
